import React from 'react';
import Departments from './Departments';
import StudentLife from './StudentLife';
import Research from './Research';
import Examinations from './Examinations';
import Complaint from './Complaint';
import ProgramsOffered from './ProgramsOffered';
import SocietyClubs from './SocietyClubs';
import SocietyClubsList from './SocietyClubsList';
import Alumni from './Alumni';
import PhdProgramResearch from './PhdProgramResearch';
import UndergraduateAdmission from './UndergraduateAdmission';
import PostgraduateAdmissions from './PostgraduateAdmissions';
import PhdAdmissions from './PhdAdmissions';
import OrdinanceType from './OrdinanceType';
import Calendar from './Calendar';
import CalendarArchive from './CalendarArchive';
import NewsLetters from './NewsLetters';
import NewsLettersArchive from './NewsLettersArchive';
import Internship from './Internship';
import InternshipArchive from './InternshipArchive';
import Achievements from './Achievements';
import AchievementsArchive from './AchievementsArchive';
import NoticesAll from './Notices';
import NoticesArchive from './NoticesArchive';
import ExamType from './ExamType';
import ExamTypeArchive from './ExamTypeArchive';
import NoticeType from './NoticeType';
import NoticeTypeArchive from './NoticeTypeArchive';
import ResearchType from './ResearchType';
import ResearchTypeArchive from './ResearchTypeArchive';
import ResearchProjects from './ResearchProjects';
import SchemeSyllabus from './SchemeSyllabus';
import SchemeSyllabusArchive from './SchemeSyllabusArchive';
import TimeTables from './TimeTables';
import TimeTablesArchive from './TimeTablesArchive';
import EventsDepartment from './EventsDepartment';
import Meetings from './Meetings';
import Forms from './Forms';
import FacultyDirectory from './FacultyDirectory';
import DepartmentLabs from './DepartmentLabs';
import AchievementsDepartment from './AchievementsDepartment';
import DepartmentPhDProgram from './DepartmentPhDProgram';
import DepartmentFacilities from './DepartmentFacilities';
import DepartmentProjects from './DepartmentProjects';
import LabourAct from './LabourAct';
import Careers from './Careers';
import Tenders from './Tenders';
import Manual from './Manual';
import Events from './Events';
import AllExams from './Exams';
import EventDetails from './EventDetails';
import NoticeDetails from './NoticeDetails';
import ExamDetails from './ExamDetails';
import AchievementDetails from './AchievementDetails';
import FacultyDetails from './FacultyDetails';
import FacultyPublications from './FacultyPublications';
import SocietyDetails from './SocietyDetails';
import TechCollaborations from './TechCollaborations';
import DynamicMiscellaneous from './DynamicMiscellaneous';
import DynamicMiscellaneousList from './DynamicMiscellaneousList';
import VisitingCompanies from './VisitingCompanies';
import Placements from './Placements';
import PlacementVideos from './PlacementVideos';
import Facilities from './Facilities';
import FacilitiesResources from './FacilitiesResources';
import FacilitiesEbooks from './FacilitiesEbooks';
import FacilitiesForms from './FacilitiesForms';
import HostelRules from './HostelRules';
import HostelEvents from './HostelEvents';
import HostelAdmissionProcedure from './HostelAdmissionProcedure';
import Glimpses from './Glimpses';
import GlimpsesDetails from './GlimpsesDetails';
import ProgramDetails from './ProgramDetails';
import EventsArchive from './EventsArchive';
import ViksitBharat from './ViksitBharat';
import Sitemap from './Sitemap';
import ResearchCorner from './ResearchCorner';
import Rekhi from './Rekhi';
import DevPage from './DevPage';
import RekhiArchive from './RekhiArchive';
import HelpFaq from './HelpFaq';

const PageStaticData = ({ pageData }) => 
{
    if( global.config.IsPrint === true ) { console.info('Page Data', pageData); }
    const appLanguage = localStorage.getItem('appLanguage') || 'en';
    if(pageData.sp_id === 0)
    {
        if(pageData.sp_name === 'EventDetails')
        {
            return <EventDetails htaccess={pageData.sp_htaccess} />
        }
        if(pageData.sp_name === 'NoticeDetails')
        {
            return <NoticeDetails htaccess={pageData.sp_htaccess} />
        }
        if(pageData.sp_name === 'ExamDetails')
        {
            return <ExamDetails htaccess={pageData.sp_htaccess} />
        }
        if(pageData.sp_name === 'AchievementDetails')
        {
            return <AchievementDetails htaccess={pageData.sp_htaccess} />
        }
        if(pageData.sp_name === 'FacultyDetails')
        {
            return <FacultyDetails htaccess={pageData.sp_htaccess} />
        }
        if(pageData.sp_name === 'FacultyPublications')
        {
            return <FacultyPublications htaccess={pageData.sp_htaccess} />
        }
        if(pageData.sp_name === 'ClubsSocietiesDetails')
        {
            return <SocietyDetails htaccess={pageData.sp_htaccess} />
        }
        if(pageData.sp_name === 'GlimpsesDetails')
        {
            return <GlimpsesDetails htaccess={pageData.sp_htaccess} />
        }
        if(pageData.sp_name === 'ProgramDetails')
        {
            return <ProgramDetails htaccess={pageData.sp_htaccess} />
        }
        else
        {
            return <DevPage /> 
        }
        
    }
    if(pageData.sp_id === 3)
    {
        return <Departments />
    }
    else if(pageData.sp_id === 5)
    {
        return <StudentLife />
    }
    else if(pageData.sp_id === 6)
    {
        return <Research />
    }
    else if(pageData.sp_id === 8)
    {
        return <Examinations />
    }
    else if(pageData.sp_id === 9)
    {
        return <Complaint />
    }
    else if(pageData.sp_id === 23)
    {
        return <ProgramsOffered />
    }
    else if(pageData.sp_id === 24)
    {
        return <SchemeSyllabus />
    }
    else if(pageData.sp_id === 25)
    {
        return <TimeTables />
    }
    else if(pageData.sp_id === 26)
    {
        return <Calendar />
    }
    else if(pageData.sp_id === 29)
    {
        return <SocietyClubs />
    }
    else if(pageData.sp_id === 30)
    {
        return <NoticeType ntId={3} spId={215} cardHeading={appLanguage === "hi" ? "छात्र सूचना बोर्ड" : "Student Notice Board"} />
    }
    else if(pageData.sp_id === 31)
    {
        return <Alumni />
    }
    else if(pageData.sp_id === 32)
    {
        return <NewsLetters />
    }
    else if(pageData.sp_id === 33)
    {
        return <Internship />
    }
    else if(pageData.sp_id === 34)
    {
        return <EventsDepartment sdId={10} cardHeading={appLanguage === "hi" ? "डीएसडब्ल्यू गतिविधियाँ" : "DSW ACTIVITIES"} />
    }
    else if(pageData.sp_id === 36)
    {
        return <PhdProgramResearch />
    }
    else if(pageData.sp_id === 40)
    {
        return <ResearchType srtId={2} spId={0} isAll={1} cardHeading={appLanguage === "hi" ? "आर्थिक सहायता" : "Financial Assistance"} />
    }
    else if(pageData.sp_id === 41)
    {
        return <ResearchType srtId={3} spId={232} isAll={0} cardHeading={appLanguage === "hi" ? "पीएच.डी. संबंधित परिपत्र/नोटिस" : "Ph.D. RELATED CIRCULARS/NOTICES"} />
    }
    else if(pageData.sp_id === 42)
    {
        return <ResearchType srtId={4} spId={0} isAll={1} cardHeading={appLanguage === "hi" ? "फॉर्म और आवेदन" : "FORMS AND APPLICATIONS"} />
    }
    else if(pageData.sp_id === 43)
    {
        return <ResearchType srtId={6} spId={0} isAll={1} cardHeading={appLanguage === "hi" ? "नियम एवं विनियम" : "RULES & REGULATIONS"} />
    }
    else if(pageData.sp_id === 44)
    {
        return <ResearchType srtId={1} spId={0} isAll={1} cardHeading={appLanguage === "hi" ? "नियम और अधिसूचनाएँ (औद्योगिक अनुसंधान और विकास)" : "RULES AND NOTIFICATIONS (INDUSTRIAL RESEARCH AND DEVELOPMENT)"} />
    }
    else if(pageData.sp_id === 45)
    {
        return <UndergraduateAdmission />
    }
    else if(pageData.sp_id === 46)
    {
        return <PostgraduateAdmissions />
    }
    else if(pageData.sp_id === 47)
    {
        return <PhdAdmissions />
    }
    else if(pageData.sp_id === 48)
    {
        return <NoticeType ntId={5} spId={219} cardHeading={appLanguage === "hi" ? "प्रवेश सम्बन्धी सूचना" : "NOTICES RELATED TO ADMISSIONS"} />
    }
    else if(pageData.sp_id === 49)
    {
        return <NoticeType ntId={6} spId={220} cardHeading={appLanguage === "hi" ? "छात्रावास प्रवेश अधिसूचनाएँ" : "Hostel Admission Notifications"} />
    }
    else if(pageData.sp_id === 52)
    {
        return <OrdinanceType otId={2} cardHeading={appLanguage === "hi" ? "परीक्षा के संचालन के लिए अध्यादेश और विनियमन" : "ORDINANCE AND REGULATION FOR THE CONDUCT OF EXAMINATION"} />
    }
    else if(pageData.sp_id === 53)
    {
        return <ExamType etId={1} cardHeading={appLanguage === "hi" ? "परीक्षाओं की दिनांक पत्रक" : "Date Sheets of Examinations"} />
    }
    else if(pageData.sp_id === 54)
    {
        return <ExamType etId={3} cardHeading={appLanguage === "hi" ? "परीक्षा प्रभाग से संबंधित सूचनाएँ" : "Notices related to Examinations Division"} />
    }
    else if(pageData.sp_id === 55)
    {
        return <ExamType etId={2} cardHeading={appLanguage === "hi" ? "परीक्षा परिणाम" : "Examination Results"} />
    }
    else if(pageData.sp_id === 57)
    {
        return <OrdinanceType otId={1} cardHeading={appLanguage === "hi" ? "अधिनियम और अध्यादेश" : "ACTS AND ORDINANCES"} />
    }
    else if(pageData.sp_id === 61)
    {
        return <Meetings mtId={1} />
    }
    else if(pageData.sp_id === 62)
    {
        return <Meetings mtId={2} />
    }
    else if(pageData.sp_id === 63)
    {
        return <Meetings mtId={3} />
    }
    else if(pageData.sp_id === 64)
    {
        return <Meetings mtId={4} />
    }
    else if(pageData.sp_id === 65)
    {
        return <Meetings mtId={5} />
    }
    else if(pageData.sp_id === 66)
    {
        return <Forms />
    }
    else if(pageData.sp_id === 74)
    {
        return <ResearchProjects />
    }
    else if(pageData.sp_id === 69 || pageData.sp_id === 76 || pageData.sp_id === 80 || pageData.sp_id === 82 || pageData.sp_id === 84 || pageData.sp_id === 86 || pageData.sp_id === 88 || pageData.sp_id === 90)
    {
        return <FacultyDirectory pageData={pageData} />
    }
    else if(pageData.sp_id === 73 || pageData.sp_id === 78 || pageData.sp_id === 93 || pageData.sp_id === 94 || pageData.sp_id === 95 || pageData.sp_id === 96 || pageData.sp_id === 97 || pageData.sp_id === 98 )
    {
        return <DepartmentLabs pageData={pageData} />
    }
    else if(pageData.sp_id === 72 || pageData.sp_id === 77 || pageData.sp_id === 99 || pageData.sp_id === 100 || pageData.sp_id === 101 || pageData.sp_id === 102 || pageData.sp_id === 103 || pageData.sp_id === 104 )
    {
        return <EventsDepartment sdId={pageData.sp_sd_id} cardHeading={appLanguage === "hi" ? "नवीनतम कार्यक्रम/ कार्यशालाएं/ सेमिनार / विशेषज्ञ व्याख्यान" : "Latest Events/ Workshops/ Seminars / Expert Lectures"} />
    }
    else if(pageData.sp_id === 71 || pageData.sp_id === 136 || pageData.sp_id === 137 || pageData.sp_id === 138 || pageData.sp_id === 139 || pageData.sp_id === 140 || pageData.sp_id === 142 || pageData.sp_id === 143 )
    {
        return <AchievementsDepartment pageData={pageData} />
    }
    else if( pageData.sp_id === 105 || pageData.sp_id === 109 || pageData.sp_id === 113 || pageData.sp_id === 117 || pageData.sp_id === 121 || pageData.sp_id === 125 || pageData.sp_id === 129 || pageData.sp_id === 133 )
    {
        return <DepartmentPhDProgram pageData={pageData} />
    }
    else if( pageData.sp_id === 106 || pageData.sp_id === 110 || pageData.sp_id === 114 || pageData.sp_id === 118 || pageData.sp_id === 122 || pageData.sp_id === 126 || pageData.sp_id === 130 || pageData.sp_id === 134 )
    {
        return <DepartmentFacilities pageData={pageData} />
    }
    else if( pageData.sp_id === 107 || pageData.sp_id === 111 || pageData.sp_id === 115 || pageData.sp_id === 119 || pageData.sp_id === 123 || pageData.sp_id === 127 || pageData.sp_id === 131 || pageData.sp_id === 135 )
    {
        return <DepartmentProjects pageData={pageData} />
    }
    else if( pageData.sp_id === 276 || pageData.sp_id === 277 || pageData.sp_id === 278 || pageData.sp_id === 279 || pageData.sp_id === 280 || pageData.sp_id === 281 || pageData.sp_id === 282 || pageData.sp_id === 283 )
    {
        return <ResearchCorner pageData={pageData} />
    }
    else if(pageData.sp_id === 145 )
    {
        return <Placements pageData={pageData} />
    }
    else if(pageData.sp_id === 146 )
    {
        return <Facilities />
    }
    else if(pageData.sp_id === 156 )
    {
        return <FacilitiesResources />
    }
    else if(pageData.sp_id === 157 )
    {
        return <FacilitiesEbooks />
    }
    else if(pageData.sp_id === 159 )
    {
        return <FacilitiesForms />
    }
    else if(pageData.sp_id === 163 )
    {
        return <NoticeType ntId={6} spId={220} cardHeading={appLanguage === "hi" ? "छात्रावास प्रवेश अधिसूचनाएँ" : "Hostel Admission Notifications"} />
    }
    else if(pageData.sp_id === 165 )
    {
        return <HostelRules />
    }
    else if(pageData.sp_id === 166 )
    {
        return <HostelEvents mtId={39} />
    }
    else if(pageData.sp_id === 168 )
    {
        return <HostelAdmissionProcedure />
    }
    else if(pageData.sp_id === 169 )
    {
        return <DynamicMiscellaneous mtId={13} />
    }
    else if(pageData.sp_id === 174 )
    {
        return <Careers />
    }    
    else if(pageData.sp_id === 176 )
    {
        return <LabourAct />
    }
    else if(pageData.sp_id === 178 )
    {
        return <NoticesArchive />
    }
    else if(pageData.sp_id === 179 )
    {
        return <Tenders />
    }    
    else if(pageData.sp_id === 180)
    {
        return <ResearchType srtId={7} spId={0} isAll={1} cardHeading={appLanguage === "hi" ? "प्री-पीएचडी के लिए दिशानिर्देश सारांश और पीएच.डी. थीसिस प्रस्तुतीकरण" : "GUIDELINES FOR PRE-PH.D. SYNOPSIS AND PH.D THESIS SUBMISSION"} />
    }
    else if(pageData.sp_id === 184 )
    {
        return <Manual />
    }
    else if(pageData.sp_id === 186 )
    {
        return <DynamicMiscellaneous mtId={3} />
    }
    else if(pageData.sp_id === 187 )
    {
        return <DynamicMiscellaneous mtId={4} />
    }
    else if(pageData.sp_id === 188 )
    {
        return <DynamicMiscellaneous mtId={5} />
    }
    else if(pageData.sp_id === 189 )
    {
        return <DynamicMiscellaneous mtId={6} />
    }
    else if(pageData.sp_id === 190 )
    {
        return <DynamicMiscellaneous mtId={7} />
    }
    else if(pageData.sp_id === 191 )
    {
        return <NoticesAll />
    }
    else if(pageData.sp_id === 192 )
    {
        return <Achievements />
    }
    else if(pageData.sp_id === 193 )
    {
        return <NoticeType ntId={4} spId={351} cardHeading={appLanguage === "hi" ? "सूचना / परिपत्र" : "Notices / Circulars"} />
    }
    else if(pageData.sp_id === 194 )
    {
        return <Events />
    }
    else if(pageData.sp_id === 197 )
    {
        return <AllExams />
    }
    else if( pageData.sp_id === 198 || pageData.sp_id === 199 || pageData.sp_id === 200 || pageData.sp_id === 201 )
    {
        return <SocietyClubsList pageData={pageData} />
    }
    else if(pageData.sp_id === 202)
    {
        return <ResearchType srtId={8} spId={0} isAll={1} cardHeading={appLanguage === "hi" ? "पीएच.डी. विनियम" : "Ph.D. Regulations"} />
    }
    else if( pageData.sp_id === 203 )
    {
        return <TechCollaborations />
    }
    else if( pageData.sp_id === 205 )
    {
        return <PlacementVideos mtId={15} />
    }
    else if( pageData.sp_id === 206 )
    {
        return <PlacementVideos mtId={16} />
    }    
    else if( pageData.sp_id === 209 )
    {
        return <DynamicMiscellaneous mtId={8} />
    }
    else if( pageData.sp_id === 210 )
    {
        return <DynamicMiscellaneous mtId={9} />
    }
    else if( pageData.sp_id === 211 )
    {
        return <VisitingCompanies />
    }
    else if( pageData.sp_id === 215 )
    {
        return <NoticeTypeArchive ntId={3} cardHeading={appLanguage === "hi" ? "छात्र सूचना बोर्ड" : "Student Notice Board"} />
    }
    else if( pageData.sp_id === 216 )
    {
        return <SchemeSyllabusArchive />
    }
    else if( pageData.sp_id === 217 )
    {
        return <TimeTablesArchive />
    }
    else if( pageData.sp_id === 218 )
    {
        return <CalendarArchive />
    }
    else if( pageData.sp_id === 219 )
    {
        return <NoticeTypeArchive ntId={5} cardHeading={appLanguage === "hi" ? "प्रवेश सम्बन्धी सूचना" : "NOTICES RELATED TO ADMISSIONS"} />
    }
    else if( pageData.sp_id === 220 )
    {
        return <NoticeTypeArchive ntId={6} cardHeading={appLanguage === "hi" ? "छात्रावास प्रवेश अधिसूचनाएँ" : "Hostel Admission Notifications"} />
    }
    else if( pageData.sp_id === 222 )
    {
        return <ExamTypeArchive etId={1} cardHeading={appLanguage === "hi" ? "परीक्षाओं की दिनांक पत्रक" : "Date Sheets of Examinations"} />
    }
    else if( pageData.sp_id === 223 )
    {
        return <ExamTypeArchive etId={3} cardHeading={appLanguage === "hi" ? "परीक्षा प्रभाग से संबंधित सूचनाएँ" : "Notices related to Examinations Division"} />
    }
    else if( pageData.sp_id === 224 )
    {
        return <ExamTypeArchive etId={2} cardHeading={appLanguage === "hi" ? "परीक्षा परिणाम" : "Examination Results"} />
    }
    else if( pageData.sp_id === 227 )
    {
        return <Glimpses />
    }
    else if(pageData.sp_id === 228 )
    {
        return <EventsArchive />
    }
    else if( pageData.sp_id === 229 )
    {
        return <AchievementsArchive />
    }
    else if(pageData.sp_id === 230)
    {
        return <NewsLettersArchive />
    }
    else if(pageData.sp_id === 231)
    {
        return <InternshipArchive />
    }
    else if(pageData.sp_id === 232)
    {
        return <ResearchTypeArchive srtId={3} cardHeading={appLanguage === "hi" ? "पीएच.डी. संबंधित परिपत्र/नोटिस" : "Ph.D. RELATED CIRCULARS/NOTICES"} />
    }
    else if(pageData.sp_id === 233)
    {
        return <NoticeTypeArchive ntId={2} cardHeading={appLanguage === "hi" ? "विश्वविद्यालय में करियर/भर्ती" : "Careers / Recruitment At University"} />
    }
    else if(pageData.sp_id === 234)
    {
        return <NoticeTypeArchive ntId={1} cardHeading={appLanguage === "hi" ? "निविदाएँ" : "TENDERS"} />
    }
    else if(pageData.sp_id === 235)
    {
        return <ViksitBharat />
    }
    else if(pageData.sp_id === 236)
    {
        return <DynamicMiscellaneousList mtId={19} />
    }
    else if(pageData.sp_id === 237)
    {
        return <DynamicMiscellaneousList mtId={20} />
    }
    else if(pageData.sp_id === 246)
    {
        return <Sitemap />
    }
    else if(pageData.sp_id === 275)
    {
        return <ResearchType srtId={10} spId={0} isAll={1} cardHeading={appLanguage === "hi" ? "विश्वविद्यालय अनुसंधान बोर्ड के कार्यवृत्त" : "University Research Board Minutes"} />
    }
    else if(pageData.sp_id === 299)
    {
        return <Rekhi />
    }
    else if(pageData.sp_id === 302)
    {
        return <RekhiArchive />
    }
    else if(pageData.sp_id === 319)
    {
        return <HelpFaq />
    }
    else if(pageData.sp_id === 349)
    {
        return <NoticesAll />
    }
    else if(pageData.sp_id === 350)
    {
        return <NoticesArchive />
    }
    else if(pageData.sp_id === 351)
    {
        return <NoticeTypeArchive ntId={4} cardHeading={appLanguage === "hi" ? "सूचना / परिपत्र" : "Notices / Circulars"} />
    }
    else if(pageData.sp_id === 352)
    {
        return <NoticeType ntId={12} spId={0} cardHeading={appLanguage === "hi" ? "डीएसडब्ल्यू नोटिस" : "DSW Notices"} />
    }
    else if(pageData.sp_id === 355)
    {
        return <NoticeType ntId={13} spId={0} cardHeading={appLanguage === "hi" ? "आईक्यूएसी नोटिस" : "IQAC Notices"} />
    }
    else if(pageData.sp_id === 373)
    {
        return <NoticeType ntId={14} spId={0} cardHeading={appLanguage === "hi" ? "मीडिया में विश्वविद्यालय" : "University in Media"} />
    }
    else
    {
        return <DevPage />
    }    
}
export default PageStaticData;